import { WebFilter } from '@foxeet/utils/classes';
import { FilterModel } from '@foxeet/domain';

export class ExternalConnectionsUnicajaAppraisalListFilterComponent extends WebFilter {
  constructor(filterName: string, defaultFilter?: FilterModel) {
    super(filterName, defaultFilter);
  }
}
